/* Source: /home/ubuntu/libredraw/frontend/editor/TemplatePicker.cl.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { X, LayoutTemplate, Workflow, Network, GitBranch, CalendarClock } from "lucide-react";
import { useModalA11y } from "./modalA11y.ts";
import { TEMPLATES } from "./templates.ts";
function TemplatePicker(props) {
  const {onPick: onPick = null, onClose: onClose = null} = props;
  function icon_for(props) {
    const {key} = props;
    if ((key === "org")) {
      return __jacJsx(Network, {"size": 18}, []);
    }
    if ((key === "mind")) {
      return __jacJsx(GitBranch, {"size": 18}, []);
    }
    if ((key === "time")) {
      return __jacJsx(CalendarClock, {"size": 18}, []);
    }
    return __jacJsx(Workflow, {"size": 18}, []);
  }
  function choose(t) {
    if (onPick) {
      onPick(t["els"]);
    }
    if (onClose) {
      onClose(null);
    }
  }
  let dialogRef = useModalA11y(() => {
    if (onClose) {
      onClose(null);
    }
  });
  return __jacJsx("div", {"className": "fixed inset-0 z-[85] flex items-center justify-center bg-black/40 p-4 backdrop-blur-sm", "onClick": _e => {
    if (onClose) {
      onClose(null);
    }
  }}, [__jacJsx("div", {"ref": dialogRef, "role": "dialog", "aria-modal": "true", "aria-labelledby": "template-title", "className": "w-full max-w-lg rounded-2xl border border-border bg-card p-6 shadow-pop", "onClick": e => {
    e.stopPropagation();
  }}, [__jacJsx("div", {"className": "flex items-center justify-between"}, [__jacJsx("div", {"className": "flex items-center gap-2"}, [__jacJsx("span", {"className": "flex size-8 items-center justify-center rounded-lg bg-primary-soft text-primary"}, [__jacJsx(LayoutTemplate, {"size": 16}, [])]), __jacJsx("h2", {"id": "template-title", "className": "text-base font-semibold"}, ["Choose a template"])]), __jacJsx("button", {"onClick": _e => {
    if (onClose) {
      onClose(null);
    }
  }, "title": "Close", "className": "flex size-8 items-center justify-center rounded-lg text-muted-foreground hover:bg-accent hover:text-foreground"}, [__jacJsx(X, {"size": 18}, [])])]), __jacJsx("p", {"className": "mt-2 text-xs text-muted-foreground"}, ["Drops a ready-made, fully editable diagram onto the canvas."]), __jacJsx("div", {"className": "mt-4 grid grid-cols-2 gap-2"}, [TEMPLATES.map(t => __jacJsx("button", {"key": t["name"], "onClick": _e => {
    choose(t);
  }, "className": "flex items-start gap-3 rounded-xl border border-border bg-card p-3 text-left transition-colors hover:border-primary hover:bg-primary-soft"}, [__jacJsx("span", {"className": "mt-0.5 flex size-8 shrink-0 items-center justify-center rounded-lg bg-muted text-muted-foreground"}, [icon_for({key: t["icon"]})]), __jacJsx("span", {"className": "min-w-0"}, [__jacJsx("span", {"className": "block text-sm font-medium text-foreground"}, [t["name"]]), __jacJsx("span", {"className": "block text-xs text-muted-foreground"}, [t["desc"]])])]))])])]);
}
/*jac:refresh-boundary*/;
export {TemplatePicker};
//# sourceMappingURL=TemplatePicker.js.map
